<template>
  <div class="hello">

    <div class="header">
      <h2>
        You are <span v-if="!user.email">anonymous</span> <span v-else>{{ user.email }}</span>
        <button class="float right"v-on:click="logout">Logout</button>
      </h2>
    </div>

    <hr>

    <p>Clicking the <em>Add Message</em> button will add a record to your user's messages<span v-if="!user.email">, even anonymously</span>.</p>

    <button v-if="user.uid"
            v-on:click="addMessage">Add Message
    </button>

    <ul>
      <li v-for="message in messages"><button v-on:click="removeMessage(message)">remove</button> {{ message }}</li>
    </ul>

  </div>
</template>

<script>
import Firebase from 'firebase'
import {db} from '../firebaseConf'

export default {
  name: 'hello',
  beforeCreate: function() {
    Firebase.auth().onAuthStateChanged(function(user) {
      if (user) {
        this.user = user
        this.$bindAsArray('messages', db.ref('messages/' + user.uid))
      } else {
        this.$router.replace('login')
      }
    }.bind(this))
  },
  data () {
    return {
      user: {},
      messages: []
    }
  },
  methods: {
    addMessage: function() {
      // https://firebase.google.com/docs/reference/js/firebase.database.Reference#push
      this.$firebaseRefs.messages.push({
        text: 'new message', timestamp: Date()
      })
    },
    removeMessage: function(message) {
      // https://firebase.google.com/docs/reference/js/firebase.database.Reference#remove
      this.$firebaseRefs.messages.child(message['.key']).remove()
    },
    logout: function() {
      Firebase.auth().signOut().then(() => {
        this.$router.replace('login')
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .header {
    padding: 5px;
    background-color: #042653;
    color: #ffffff
  }
  hr {
    border-color: #042653;
    margin: 20px 0
  }
</style>



// WEBPACK FOOTER //
// Hello.vue?220e13f0